import * as React from "react";
import { Input, AcceptedInputType } from "../Input";

const styles = require("./styles.module.scss");

interface EditableProps {
  value: any;
  onSave: (value: any) => Promise<any>;
  onSuccess?: () => void;
  acceptedInput: AcceptedInputType;
  rows?: number;
  clearOnSave?: boolean;

  placeholder?: string;
  autoFocus?: boolean;
}

export default class Editable extends React.Component<
  EditableProps,
  {
    initialValue: any;
    value: any;
    saveButtonText: string;
    edited: boolean;
  }
> {
  constructor(props) {
    super(props);
    this.state = {
      initialValue: props.value,
      value: props.value,
      saveButtonText: "Save",
      edited: false,
    };
  }

  onChange = ({ target: { value } }) => {
    const { initialValue } = this.state;
    this.setState({ value, edited: value !== initialValue });
  };

  render() {
    const { acceptedInput, rows, autoFocus, placeholder } = this.props;
    const { value, saveButtonText, edited } = this.state;

    return (
      <form
        className={styles.editable}
        onSubmit={e => {
          e.preventDefault();
          const { onSave, onSuccess = () => {}, clearOnSave = false } = this.props;
          const { value } = this.state;
          onSave(value).then(() => {
            this.setState({ saveButtonText: "Saved", value: clearOnSave ? "" : value }, onSuccess);
          });
        }}
      >
        <Input
          placeholder={placeholder}
          autoFocus={autoFocus}
          acceptedInput={acceptedInput}
          rows={rows}
          value={value}
          onChange={this.onChange}
        />
        <button type="submit" disabled={!edited || (!edited && value === "")}>
          {saveButtonText}
        </button>
      </form>
    );
  }
}
